import React from 'react';

const STATUS_BADGE = {
  pending: 'bg-amber-50 text-amber-800 border-amber-200',
  meeting_scheduled: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  meeting_done: 'bg-surface-muted text-ink border-border',
  booked: 'bg-green-50 text-green-800 border-green-200',
  lead_not_responsive: 'bg-orange-50 text-orange-800 border-orange-200',
  lead_cancelled: 'bg-red-50 text-red-700 border-red-200',
  rejected: 'bg-rose-50 text-rose-700 border-rose-200',
  upcoming: 'bg-sky-50 text-sky-800 border-sky-200',
  due: 'bg-amber-50 text-amber-800 border-amber-200',
  overdue: 'bg-red-50 text-red-700 border-red-200',
  completed: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  dismissed: 'bg-gray-100 text-gray-600 border-gray-200',
};

const LeadStatusBadge = ({ status, label }) => (
  <span
    className={`inline-flex px-2 py-0.5 rounded-full text-[11px] font-medium border capitalize ${
      STATUS_BADGE[status] || 'bg-gray-100 text-gray-700 border-gray-200'
    }`}
  >
    {(label || status || '').replace(/_/g, ' ')}
  </span>
);

export default LeadStatusBadge;
